export function normalizeSaleUnit(value) {
  const original = String(value || "").trim();
  const unit = original.toLowerCase();
  if (["kg", "kgs", "kilogramo", "kilogramos"].includes(unit)) return "kg";
  if (["gr", "g", "gramo", "gramos"].includes(unit)) return "gr";
  if (["un", "unidad", "unidades"].includes(unit)) return "un";
  return original;
}

export function isWeightedUnit(value) {
  return ["kg", "gr"].includes(normalizeSaleUnit(value));
}

export function pricingQuantity(quantity, saleUnit) {
  return normalizeSaleUnit(saleUnit) === "gr" ? Number(quantity) / 1000 : Number(quantity);
}

export function roundedLineTotal(unitPrice, quantity, saleUnit) {
  const raw = Number(unitPrice) * pricingQuantity(quantity, saleUnit);
  return Number.isFinite(raw) ? Math.round(raw / 10) * 10 : 0;
}

export function stockUnitLabel(value) {
  return normalizeSaleUnit(value) || "un";
}

export function priceUnitLabel(value) {
  return isWeightedUnit(value) ? "/ kg" : "";
}

export function analyticsUnitLabel(value) {
  return isWeightedUnit(value) ? "kg" : stockUnitLabel(value);
}
